/**
 * OTHER DOMAIN CONFIGURATION
 * Cấu hình cho lĩnh vực "Khác" - dành cho các lĩnh vực không thuộc các domain đã có
 */
export const domainConfig = {
  // === BASIC INFO ===
  id: "other",
  name: "Khác",
  icon: "🌟",
  description:
    "Tạo nội dung cho các lĩnh vực khác không thuộc các danh mục có sẵn",

  // === PROJECT TYPES ===
  // Không có project types, chỉ có content types
  projectTypes: {},

  // === CONTENT TYPES ===
  // Không sử dụng content types cho domain "other"
  contentTypes: {},

  // === PUBLISHING PLATFORMS (Optional) ===
  publishingPlatforms: {
    // Để trống sẽ dùng shared platforms
  },

  // === DEFAULT VALUES ===
  defaults: {
    projectType: "", // Không có project type mặc định
    contentType: "", // Không có content type mặc định
    postLength: "Trung bình",
    postStyles: ["Chuyên nghiệp"],
  },

  // === UI LABELS ===
  labels: {
    projectTypeLabel: "Loại hình",
    contentTypeLabel: "Tôi muốn tạo nội dung để",
    projectInfoLabel: "Thông tin dịch vụ",
    projectInfoPlaceholder:
      "Nhập thông tin chi tiết về sản phẩm/dịch vụ của bạn...",
    targetCustomerLabel: "Khách hàng mục tiêu",
    targetCustomerPlaceholder: "Mô tả đối tượng khách hàng mục tiêu của bạn...",
  },

  // === DOMAIN-SPECIFIC SETTINGS ===
  settings: {
    hideProjectTypeDropdown: true, // Ẩn dropdown loại hình
    hideContentTypeDropdown: true, // Ẩn dropdown loại nội dung
    requiresLocation: false,
    requiresPrice: false,
  },
};
